import React, { Fragment, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import {
    getTermsConditionKeyValue,
    getWarehouseKeyValueDetailsList,
    getInterStateTaxKeyValueList,
    getIntraStateTaxKeyValueList,
    ItemListByWarePrice1,
    getVendorDetails,
    getPurchaseDetails,
    updatePurchaseOrder,
    addPurchaseOrder,
    addDirectBillRecord1,
    addBillOrder,
    getVendorByWare,
} from "../../../services/index";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { storeOptionsByWarehouseId } from "../../../services/Purchase/StoreService";
import { getRackByStore } from "../../../services/Purchase/RackService";
import { getCellByRack, getPalletByCell } from "../../../services/Purchase/CellService";
const defaultItemBatchDetails = {
    batchQuantity: 0,
    batchNumber: "",
    batchManufacturingDate: "",
    batchExpiredDate: "",
    store: "",
    storeValue: "",
    rack: "",
    rackValue: "",
    cell: "",
    cellValue: "",
    pallete: "",
    palletValue: ""
};

const BillNew = () => {
    let location = useLocation();
    let orgDetail = JSON.parse(localStorage.getItem("orgDetail"));
    let directBill = location?.state?.directBill;
    let { id } = useParams();
    let billId;
    if (location.state === "bill") {
        billId = id;
    }

    let navigate = useNavigate();
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);

    const [purchaseInfo, setPurchaseInfo] = useState({
        vendor: "",
        warehouse: "",
        taxType: "",
        reference: "",
        orderDate: date1,
        shipDate: date1,
        invoiceNumber: "",
        invoiceDate: date1,
        notes: "",
        terms: "",
        subTotal: 0.0,
        total: 0.0,
        shipCharge: "",
        netShip: 0.0,
        netTax: 0,
        shipTax: "",
        tcsRate: 0.00,
        discountAmt: 0,
    });

    const tempRows = {
        item: {
            value: "",
            label: "",
        },
        billBatchBeansList: [defaultItemBatchDetails],
        requestedQuantity: 1,
        receivedQuantity: 1,
        pendingQuantity: 0,
        taxes: "",
        rate: 0,
        amount: 0,
        isFloating: false,
        itemTitle: "",
        itemUuid: "",
        deleted: false,
    };

    const [rows, setRows] = useState([tempRows]);
    const [loading, setLoading] = useState(false);
    const [wareOptions, setWareOptions] = useState("");
    const [vendorOptions, setVendorOptions] = useState("");
    const [termsOptions, setTermsOptions] = useState("");
    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");
    const [taxOptions, setTaxOptions] = useState("");
    const [storeOptions, setStoreOptions] = useState([]);
    const [rackOptions, setRackOptions] = useState([]);
    const [cellOptions, setCellOptions] = useState([]);
    const [palleteOptions, setPalleteOptions] = useState([])
    const [selectedStore, setSelectedStore] = useState(null);
    const [itemLoading, setItemLoading] = useState(false);
    let abortController = null;

    useEffect(() => {
        callBasicAPI();
        if (id) {
            getPurchaseDetails1(id);
        }
        if (billId) {
            getPurchaseDetails1(billId);
        }
    }, []);


    useEffect(() => {
        if (purchaseInfo.warehouse.length <= 0) {
            return;
        }
        storeOptionsByWarehouseId(purchaseInfo.warehouse.value).then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setStoreOptions(options || []);
            } else {
                handleToast(res);
            }
        });
    }, [purchaseInfo.warehouse]);

    const getPurchaseDetails1 = (Id) => {
        getPurchaseDetails(Id).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                let itemList = res.responsePacket.items;
                let a = res.responsePacket.address;
                let wId = d.warehouseId;
                let pId = d.priceListId;
                handleGetVendor(wId);
                let sub1 = 0;
                itemList?.map((a) => {
                    sub1 = sub1 + a.amount;
                });

                if (
                    Number(sub1).toFixed(2) !==
                    Number(d.subTotalAmount).toFixed(2)
                ) {
                    toast.error("subtotal mismatch");
                }

                d.address?.map((a) => {
                    if (a.addressType === "Billing") {
                        d.billAdd = a;
                    }

                    if (a.addressType === "Shipping") {
                        d.shipAdd = a;
                    }
                });

                getVendorDetails(d.vendorId).then((res) => {
                    if (res.errorCode === 0) {
                        let d1 = res.responsePacket;

                        let custGst12 = d1.gstNumber?.substring(0, 2);
                        let orgGst12 = orgDetail?.gstNumber?.substring(0, 2);

                        if (custGst12 === orgGst12) {
                            handleGetItems(wId, pId, "intra", itemList);
                            getIntraStateTaxKeyValueList().then((res) => {
                                const options = res.responsePacket?.map(
                                    (a) => ({
                                        label: a.title,
                                        value: a.recordId,
                                        rate: a.rate,
                                        taxType: a.taxType,
                                    })
                                );
                                setTaxOptions(options);
                            });
                        } else {
                            handleGetItems(wId, pId, "inter", itemList);
                            getInterStateTaxKeyValueList().then((res) => {
                                const options = res.responsePacket?.map(
                                    (a) => ({
                                        label: a.title,
                                        value: a.recordId,
                                        rate: a.rate,
                                        taxType: a.taxType,
                                    })
                                );
                                setTaxOptions(options);
                            });
                        }
                    }
                });

                let vendor1 = {
                    recordId: d.vendorId,
                    title: d.vendorTitle,
                    value: d.vendorId,
                    label: d.vendorTitle,
                    billAdd: d.billAdd,
                    shipAdd: d.shipAdd,

                    addressList: a,
                    phone: d.vendorMobileNumber,
                    itemPriceListTitle: d.priceListTitle,
                    itemPriceListRecordId: d.priceListId,

                    paymentTermRecordId: d.paymentTermsId,
                    paymentTermTitle: d.paymentTermsTitle,
                };

                let warehouse = {
                    value: d.warehouseId,
                    label: d.warehouseTitle,
                };
                let terms = {
                    value: d.termsConditionId,
                    label: d.termsCondition,
                };
                let shipTax = {
                    value: d.shippingChargeTaxId,
                    label: d.shippingChargeTaxTitle,
                    rate: d.shippingChargeTaxRate,
                };
                let netTax = 0;
                itemList?.map((c) => {
                    netTax += c.taxes.amount;
                });

                // note:  d.shippingCharges=netShip
                // so we need to calculate shipCharge i.e without tax

                let shipCharge =
                    d.shippingCharges / (1 + d.shippingChargeTaxRate * 0.01);

                setPurchaseInfo({
                    ...purchaseInfo,
                    vendor: vendor1,
                    warehouse: warehouse,
                    terms: terms,
                    shipTax: shipTax,
                    shipCharge: Number(shipCharge.toFixed(2)),
                    netTax: netTax,

                    reference: d.referenceNo,
                    orderDate: d.purchaseOrderDate,
                    shipDate: d.expectedShipmentDate,
                    notes: d.vendorNote,
                    subTotal: d.subTotalAmount,
                    total: d.totalAmount,
                    netShip: d.shippingCharges,

                    purchaseOrderNo: d?.purchaseOrderNo,
                    purchaseOrderId: d?.recordId,
                    taxType: "",
                });
            } else {
                handleToast(res);
            }
        });
    };

    const handleAddNewRow = () => {
        setRows([...rows, tempRows]);
        handleFilterItems(rows);
    };

    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
        handleFilterItems(obj);
        handleSubTotal(obj);
    };

    const handleToast = (res) => {
        toast(res.message);
    };

    const callBasicAPI = () => {
        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWareOptions(options);
            } else {
                handleToast(res);
            }
        });

        getTermsConditionKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options?.map((a) => {
                    setPurchaseInfo({
                        ...purchaseInfo,
                        terms: a,
                    });
                });
                setTermsOptions(options);
            } else {
                handleToast(res);
            }
        });
    };

    const freshVendor = (aa, d1, taxType) => {
        // setItemOptions("");
        // setItemOptions2("");
        setRows([tempRows]);
        setPurchaseInfo({
            ...purchaseInfo,
            taxType: taxType,
            vendor: d1,
            shipTax: aa[0],
            netTax: 0,
            subTotal: 0,
            netShip: 0,
            shipCharge: 0,
            total: 0,
        });
    };

    const freshWare = (e) => {
        setItemOptions("");
        setItemOptions2("");
        setRows([tempRows]);
        setPurchaseInfo({
            ...purchaseInfo,
            vendor: "",
            warehouse: e,
            netTax: 0,
            subTotal: 0,
            netShip: 0,
            shipCharge: 0,
            total: 0,
        });
    };

    const handleVendor = (e) => {
        getVendorDetails(e.value).then((res) => {
            if (res.errorCode === 0) {
                let d1 = res.responsePacket;
                setPurchaseInfo({ ...purchaseInfo, vendor: d1 });

                d1.value = d1.recordId;
                d1.label = d1.title;

                if (!d1.gstNumber) {
                    toast.error("vendor GST not found");
                }

                d1.addressList?.map((a) => {
                    if (a.addressType === "Billing") {
                        d1.billAdd = a;
                    }

                    if (a.addressType === "Shipping") {
                        d1.shipAdd = a;
                    }
                });

                let wId = purchaseInfo.warehouse.value;
                let pId = d1.itemPriceListRecordId;

                let custGst12 = d1.gstNumber?.substring(0, 2);
                let orgGst12 = orgDetail?.gstNumber?.substring(0, 2);

                if (custGst12 === orgGst12) {
                    getIntraStateTaxKeyValueList().then((res) => {
                        let d = res.responsePacket;
                        const options = d?.map((a) => ({
                            label: a.title,
                            value: a.recordId,
                            rate: a.rate,
                            taxType: a.taxType,
                        }));
                        const aa = options.filter(
                            (c) => c.taxType === "GST" && c.rate === 18.0
                        );
                        setTaxOptions(options);
                        freshVendor(aa, d1, "intra");
                        handleGetItems(wId, pId, "intra");
                    });
                } else {
                    getInterStateTaxKeyValueList().then((res) => {
                        let d = res.responsePacket;
                        const options = d?.map((a) => ({
                            label: a.title,
                            value: a.recordId,
                            rate: a.rate,
                            taxType: a.taxType,
                        }));
                        const aa = options.filter(
                            (c) => c.taxType === "IGST" && c.rate === 18.0
                        );
                        setTaxOptions(options);
                        freshVendor(aa, d1, "inter");
                        handleGetItems(wId, pId, "inter");
                    });
                }
            } else {
                handleToast(res);
            }
        })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleWarehouse2 = (e) => {
        let wId = e.value;
        handleGetVendor(wId);
        freshWare(e);
    };

    const handleGetVendor = (wId) => {
        getVendorByWare(wId)
            .then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.recordId,
                        label: d.title,
                    }));
                    setVendorOptions(options);
                } else {
                    toast(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleGetItems = (wId, pId, taxType1, itemList) => {
        setItemLoading(true);
        if (abortController) {
            abortController.abort();
        }

        abortController = new AbortController();
        const { signal } = abortController;
        ItemListByWarePrice1(wId, pId, null, signal)
            .then((res) => {
                if (res.errorCode === 0) {
                    let d = res.responsePacket;
                    const options = d?.map((a) => ({
                        value: a.title,
                        label: (
                            <>
                                <div>{a.title}</div>
                                <div>
                                    stock: {a.currentStockBoxQuantity} rate:{" "}
                                    {a.purchasePriceValue}
                                </div>
                            </>
                        ),
                        itemId: a.recordId,
                        title: a.title,
                        taxes:
                            taxType1 === "inter"
                                ? a.interstateTax
                                : a.intrastateTax,
                        isFloating: a.isFloating,
                        rate: a.purchasePriceValue,
                        units: [
                            { value: a.itemUnitId, label: a.itemUnitTitle },
                            { value: a.packUnitId, label: a.packUnitTitle },
                        ],
                        unit1: { value: a.packUnitId, label: a.packUnitTitle },
                    }));

                    if (itemList) {
                        let tempRows = [];

                        options?.map((a1) => {
                            itemList?.map((c) => {
                                if (a1.itemId === c.itemUuid) {
                                    let obj = {
                                        item: {
                                            label: c.itemTitle,
                                            value: c.itemUuid,
                                        },
                                        itemUuid: c.itemUuid,
                                        itemTitle: c.itemTitle,
                                        isFloating: c?.isFloating,
                                        amount: c.amount,
                                        requestedQuantity: c.quantity,
                                        receivedQuantity: c.quantity,
                                        pendingQuantity: 0,
                                        taxes: c.taxes,
                                        rate: c.rate,
                                        hsnSac: c.hsnSac,
                                        hsnUuid: c.hsnId,
                                        units: a1.units,
                                        unit1: {
                                            value: c?.unitId,
                                            label: c?.unit,
                                        },
                                        unit: c?.unit,
                                        unitId: c?.unitId,
                                        billBatchBeansList: [
                                            defaultItemBatchDetails,
                                        ],
                                    };
                                    tempRows.push(obj);
                                }
                            });
                        });
                        setRows(tempRows);
                    }

                    setItemOptions(options);
                    setItemOptions2(options);
                    setItemLoading(false);
                } else {
                    handleToast(res);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleData = (e, key) => {
        setPurchaseInfo({
            ...purchaseInfo,
            [e.target.name]: e.target.value,
        });
    };

    const handleTerms = (e) => {
        setPurchaseInfo({
            ...purchaseInfo,
            terms: e,
        });
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item.value = e.itemId;
        obj[i].item.label = e.title;
        obj[i].rate = e.rate;
        obj[i].isFloating = e.isFloating;
        obj[i].itemUuid = e.itemId;
        obj[i].itemTitle = e.title;
        obj[i].taxes = e.taxes;
        obj[i].amount = e.rate * obj[i].receivedQuantity;
        obj[i].taxes.amount = obj[i].amount * e.taxes.rate * 0.01;

        obj[i].units = e.units;
        obj[i].unit1 = e.units[0];
        obj[i].unit = e.unit1.label;
        obj[i].unitId = e.unit1.value;

        setRows(obj);
        handleSubTotal(obj);
        handleFilterItems(obj);
    };

    const handleFilterItems = (rows) => {
        var send = false;
        var filterOptions = [];
        itemOptions2 &&
            itemOptions2?.map((a) => {
                rows &&
                    rows?.map((b) => {
                        if (a.itemId === b?.item?.value) {
                            send = true;
                        }
                    });
                if (!send) {
                    filterOptions.push(a);
                }
                send = false;
            });
        setItemOptions(filterOptions);
    };
    const handleUnit = (e, i) => {
        const obj = [...rows];

        obj[i].unit1 = { value: e.value, label: e.label };

        obj[i].unit = e.label;
        obj[i].unitId = e.value;
        setRows(obj);
    };
    const handleQuantity = (e, i) => {
        const { name, value } = e.target;
        const obj = [...rows];
        if (name === "requestedQuantity") {
            obj[i].requestedQuantity = parseFloat(value);
        }
        if (name === "receivedQuantity") {
            obj[i].receivedQuantity = parseFloat(value);
            obj[i].amount = obj[i].rate * parseFloat(value);
            obj[i].taxes.amount = obj[i].amount * obj[i].taxes.rate * 0.01;
        }
        obj[i].pendingQuantity = obj[i].requestedQuantity - obj[i].receivedQuantity;

        setRows(obj);
        handleSubTotal(obj);
    };

    const handleSubTotal = (rows) => {
        let sum2 = 0;
        let netTax = 0;
        let netShip = purchaseInfo.netShip;
        let tcsRate = purchaseInfo.tcsRate;
        let rows2 = rows.filter((a) => a.item.value !== "");

        rows2 && rows2?.map((data) => {
            netTax += data.taxes.amount;
            sum2 += data.amount;
            setPurchaseInfo({
                ...purchaseInfo,
                netTax: netTax,
                subTotal: sum2.toFixed(2),
                total: (sum2 + netShip + netTax + tcsRate).toFixed(2),
            });
        });
    };

    const handleRate = (e, i) => {
        if (e.target.value >= 1) {
            const obj = [...rows];
            if (!obj[i].isFloating) return;
            obj[i].rate = Number(e.target.value);
            obj[i].amount = obj[i].receivedQuantity * Number(e.target.value);
            obj[i].taxes.amount = obj[i].amount * obj[i].taxes.rate * 0.01;

            setRows(obj);
            handleSubTotal(obj);
        }
    };

    const handleTcsRate = (e) => {
        let tcsRate = Number(e.target.value);
        let netShip = purchaseInfo.shipCharge + purchaseInfo.shipCharge * purchaseInfo?.shipTax?.rate * 0.01;
        let netTotal = Number(purchaseInfo.subTotal) + netShip + purchaseInfo.netTax + tcsRate;
        setPurchaseInfo({
            ...purchaseInfo,
            tcsRate: tcsRate,
            total: netTotal,
        });
    }

    const handleShipCharge = (e) => {
        let ShipCharge = Number(e.target.value);
        let netShip = ShipCharge + ShipCharge * purchaseInfo?.shipTax?.rate * 0.01;
        let netTotal = Number(purchaseInfo.subTotal) + netShip + purchaseInfo.netTax + purchaseInfo.tcsRate;

        setPurchaseInfo({
            ...purchaseInfo,
            netShip: netShip,
            shipCharge: ShipCharge,
            total: netTotal,
        });
    };

    const handleShipTax = (e) => {
        let netShip = purchaseInfo.shipCharge + purchaseInfo.shipCharge * e.rate * 0.01;
        let netTotal = Number(purchaseInfo.subTotal) + netShip + purchaseInfo.netTax + purchaseInfo.tcsRate;

        setPurchaseInfo({
            ...purchaseInfo,
            shipTax: e,
            netShip: netShip,
            total: netTotal,
        });
    };

    const handleDiscount = (e) => {
        let value = Number(e.target.value);
        if (value > purchaseInfo?.total) {
            value = purchaseInfo.total;
        }
        setPurchaseInfo({
            ...purchaseInfo,
            discountAmt: value
        });
    };

    // Returns an error message when any GRN item is missing mandatory batch details, otherwise null.
    const validateBatchDetails = (items) => {
        for (const item of items) {
            const { receivedQuantity, itemTitle, billBatchBeansList } = item;
            const label = itemTitle || "item";
            if (!billBatchBeansList || billBatchBeansList.length === 0) {
                return `Batch details are required for ${label}`;
            }
            let total = 0;
            for (let j = 0; j < billBatchBeansList.length; j++) {
                const b = billBatchBeansList[j];
                const rowLabel = `${label} (batch row ${j + 1})`;
                const qty = parseFloat(b.batchQuantity);
                if (isNaN(qty) || qty <= 0) {
                    return `Batch quantity must be greater than 0 for ${rowLabel}`;
                }
                if (!b.batchNumber || !String(b.batchNumber).trim()) {
                    return `Batch number is required for ${rowLabel}`;
                }
                if (!b.batchManufacturingDate) {
                    return `Manufacturing date is required for ${rowLabel}`;
                }
                if (!b.batchExpiredDate) {
                    return `Expiry date is required for ${rowLabel}`;
                }
                if (b.batchExpiredDate < b.batchManufacturingDate) {
                    return `Expiry date cannot be before manufacturing date for ${rowLabel}`;
                }
                if (!b.storeValue) {
                    return `Store is required for ${rowLabel}`;
                }
                if (!b.rackValue) {
                    return `Rack is required for ${rowLabel}`;
                }
                if (!b.cellValue) {
                    return `Cell is required for ${rowLabel}`;
                }
                if (!b.palletValue) {
                    return `Pallet is required for ${rowLabel}`;
                }
                total += qty;
            }
            const received = parseFloat(receivedQuantity);
            if (Math.abs(total - received) > 0.0001) {
                return `Total batch quantity (${total}) must equal received quantity (${received}) for ${label}`;
            }
        }
        return null;
    };

    const handleSave = (e) => {
        if (purchaseInfo.vendor === "") {
            toast("Select vendor");
            return;
        }

        if (purchaseInfo.warehouse === "") {
            toast("Select warehouse");
            return;
        }
        if (purchaseInfo.terms === "") {
            toast("Select terms");
            return;
        }
        if (purchaseInfo.invoiceNumber === "") {
            toast("Select invoice number");
            return;
        }
        setLoading(true);
        rows?.map((a) => {
            if (id) {
                a.deleted = false;
            }
        });

        let dummy = rows.filter((a) => a.item.value !== "");
        const rows2 = dummy.map((value) => {
            const _batch = value.billBatchBeansList.map((batch) => {
                const { store, rack, cell, pallete, ...rest } = batch;
                return { ...rest };
            })
            const { item, units, unit1, ...rest1 } = value;
            const _value = {
                ...rest1,
                quantity: parseFloat(value.receivedQuantity)
            }
            return {
                ..._value,
                billBatchBeansList: _batch
            }
        })
        // Batch details (Qty, Batch, Mfg, Expiry, Store, Rack, Cell, Pallet) are mandatory for every GRN item.
        const batchError = validateBatchDetails(rows2);
        if (batchError) {
            toast.error(batchError);
            setLoading(false);
            return;
        }

        if (rows2.length === 0) {
            toast("Select item");
            setLoading(false);
            return;
        }

        let netTot = Number(purchaseInfo?.total).toFixed(2);
        let t2 = netTot.toString()?.split(".")[1];
        let rounding;
        if (t2 > 49) {
            netTot = Number(purchaseInfo?.total).toFixed(0);
            let a = 100 - t2;
            rounding = "0." + a;
        } else {
            rounding = "-0." + t2;
            netTot = netTot.toString()?.split(".")[0];
        }

        let sub1 = 0;
        rows2?.map((a) => {
            sub1 = sub1 + a.amount;
        });

        if (Number(sub1).toFixed(2) !== Number(purchaseInfo?.subTotal).toFixed(2)) {
            toast.error("subtotal mismatch");
        }

        let abc = rows2.some((a) => a?.taxes?.taxId);

        if (!abc) {
            toast.error("item Tax mismatch");
            return;
        }

        let purchaseRequest = {
            totalAmount: netTot,
            taxType: purchaseInfo.taxType === "Inter" ? "IGST" : "GST",
            roundOffAmount: Number(rounding),
            roundOffTitle: "Round off to nearest zero",
            roundOffId: 1,

            totalTax: Number(purchaseInfo?.netTax).toFixed(2),
            taxValue: Number(purchaseInfo?.netTax).toFixed(2),
            items: rows2,
            billItemsList: rows2,
            address: purchaseInfo.vendor.addressList,
            vendorId: purchaseInfo.vendor.recordId,
            vendorTitle: purchaseInfo.vendor.title,
            vendorMobileNumber: purchaseInfo.vendor.phone,
            vendorNote: purchaseInfo.notes,
            purchaseOrderStatusEnum: "Confirmed",
            tcsRate: purchaseInfo.tcsRate,
            discountAmt: purchaseInfo.discountAmt,
            isDelivered: false,
            isPacked: false,
            isShipped: false,
            isDiscountAtTransaction: true,
            isPaid: true,
            isReceived: false,
            isTcs: true,
            expectedShipmentDate: purchaseInfo.shipDate,
            purchaseOrderDate: purchaseInfo.orderDate,
            paymentTermsId: purchaseInfo.vendor.paymentTermRecordId,
            paymentTermsTitle: purchaseInfo.vendor.paymentTermTitle,

            priceListId: purchaseInfo.vendor.itemPriceListRecordId,
            priceListTitle: purchaseInfo.vendor.itemPriceListTitle,
            subTotalAmount: Number(purchaseInfo?.subTotal).toFixed(2),
            termsCondition: purchaseInfo.terms.label,
            termsConditionId: purchaseInfo.terms.value,

            warehouseId: purchaseInfo.warehouse.value,
            warehouseTitle: purchaseInfo.warehouse.label,
            referenceNo: purchaseInfo.reference,

            invoiceNumber: purchaseInfo.invoiceNumber,
            invoiceDate: purchaseInfo.invoiceDate,

            shippingCharges: purchaseInfo?.netShip,
            shippingChargeTaxRate: purchaseInfo?.shipTax?.rate,
            shippingChargeTaxId: purchaseInfo?.shipTax?.value,
            shippingChargeTaxTitle: purchaseInfo?.shipTax?.label,

            purchaseOrderNo: "SO",
            purchaseOrderStatusEnum: "Confirmed",
        };

        if (billId) {
            purchaseRequest.motorVehicleNo = purchaseInfo.motorVehicleNo;
            purchaseRequest.billNo = "BO";
            purchaseRequest.orderNo = "SO";
            purchaseRequest.purchaseOrderNo = purchaseInfo?.purchaseOrderNo;
            purchaseRequest.purchaseOrderId = purchaseInfo?.purchaseOrderId;
            purchaseRequest.billDate = purchaseInfo?.orderDate;
            purchaseRequest.itemsList = rows2;
        }

        if (directBill) {
            addDirectBillRecord1(purchaseRequest)
                .then((res) => {
                    if (res.errorCode === 0) {
                        navigate("/bills");
                        handleToast(res);
                        setLoading(false);
                    } else {
                        handleToast(res);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    setLoading(false);
                    return;
                });
        } else {
            if (billId) {
                addBillOrder(purchaseRequest)
                    .then((res) => {
                        if (res.errorCode === 0) {
                            navigate("/bills");
                            handleToast(res);
                            setLoading(false);
                        } else {
                            handleToast(res);
                            setLoading(false);
                        }
                    })
                    .catch(() => {
                        toast.error("server error");
                        setLoading(false);
                        return;
                    });
            } else {
                if (id) {
                    updatePurchaseOrder(id, purchaseRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/purchase");
                                handleToast(res);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                } else {
                    addPurchaseOrder(purchaseRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/purchase");
                                handleToast(res);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                }
            }
        }
    };

    const addNewItemBachDetailRow = (i) => {
        const _rows = [...rows];
        const requiredRow = _rows[i];
        let { billBatchBeansList } = requiredRow;
        requiredRow.billBatchBeansList = [
            ...billBatchBeansList,
            defaultItemBatchDetails,
        ];
        setRows(_rows);
    };

    const removeItemBachDetailRow = (i, j) => {
        const _rows = [...rows];
        const requiredRow = _rows[i];
        if (!requiredRow.billBatchBeansList || requiredRow.billBatchBeansList.length <= 1) {
            toast.error("At least one batch row is required for every item");
            return;
        }
        requiredRow.billBatchBeansList.splice(j, 1);
        setRows(_rows);
    };

    const itemDetailTextChange = (e, i, j) => {
        const { name, value } = e.target;
        const _rows = [...rows];
        const requiredRow = _rows[i];
        let { billBatchBeansList } = requiredRow;
        let requiredItemBatchDetailRow = billBatchBeansList[j];
        const newItemBatchDetailRow = {
            ...requiredItemBatchDetailRow,
            [name]: value,
        };
        billBatchBeansList[j] = billBatchBeansList[j];
        requiredRow.billBatchBeansList[j] = newItemBatchDetailRow;

        setRows(_rows);
    };

    const getRackList = (uuid) => {
        getRackByStore(uuid).then((res) => {
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }))
            setRackOptions(_res || []);
        })
    }

    const getCellList = (uuid) => {
        getCellByRack(uuid).then((res) => {
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }))
            setCellOptions(_res || []);
        })
    }
    const getPalleteOptions = (uuid) => {
        getPalletByCell(uuid).then((res) => {
            const _res = res.responsePacket?.map((item) => ({
                label: item.value,
                value: item.key
            }))
            setPalleteOptions(_res || []);
        })
    }

    const handleSelectBeanBatch = (e, name, i, j) => {
        const _rows = [...rows];
        const requiredRow = _rows[i];
        const { billBatchBeansList } = requiredRow;
        let requiredItemBatchDetailRow = billBatchBeansList[j];
        let newItemBatchDetailRow;


        if (name === "store") {
            newItemBatchDetailRow = {
                ...requiredItemBatchDetailRow,
                store: e,
                storeValue: e.value,
                cell: "",
                cellValue: "",
                rack: "",
                rackValue: "",
                pallete: "",
                palletValue: ""
            };
            getRackList(e.value);
            setSelectedStore(e);
            setCellOptions([]);
            setPalleteOptions([])
        }

        if (name === "rack") {
            newItemBatchDetailRow = {
                ...requiredItemBatchDetailRow,
                rack: e,
                rackValue: e.value,
                cell: "",
                cellValue: "",
                pallete: "",
                palletValue: ""
            };
            getCellList(e.value);

        }

        if (name === "cell") {
            newItemBatchDetailRow = {
                ...requiredItemBatchDetailRow,
                cell: e,
                cellValue: e.value,
                pallete: "",
                palletValue: ""

            };
            getPalleteOptions(e.value)

        }
        if (name === "pallete") {
            newItemBatchDetailRow = {
                ...requiredItemBatchDetailRow,
                pallete: e,
                palletValue: e.value
            };
        }
        billBatchBeansList[j] = billBatchBeansList[j];
        requiredRow.billBatchBeansList[j] = newItemBatchDetailRow;
        setRows(_rows);
    }

    return (
        <>
            <div className="fill list-header d-flex justify-content-between align-items-center bg-white p-3 border-bottom">
                <h3 className="float-left">
                    <ArticleIcon />
                    &nbsp;&nbsp;
                    {directBill
                        ? "DIRECT GRN"
                        : billId
                            ? "NEW BILL"
                            : id
                                ? "EDIT PURCHASE ORDER"
                                : "NEW PURCHASE ORDER"}
                    &nbsp;&nbsp;{purchaseInfo?.purchaseOrderNo}
                </h3>
            </div>

            <div
                className="scroll-y noscroll-x fill body scrollbox"
                style={{ marginLeft: "15px" }}
            >
                <div className="item-creation" autoComplete="off">
                    <div className="primary-info white-bg">
                        <div className="item-new">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Warehouse
                                        </label>
                                        <div className="col-lg-5">
                                            <Select
                                                onChange={(e) =>
                                                    handleWarehouse2(e)
                                                }
                                                isDisabled={
                                                    wareOptions ? false : true
                                                }
                                                options={wareOptions}
                                                value={purchaseInfo.warehouse}
                                            />
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Vendor
                                        </label>

                                        <div className="col-lg-5">
                                            <Select
                                                isDisabled={
                                                    purchaseInfo.warehouse &&
                                                        vendorOptions
                                                        ? false
                                                        : true
                                                }
                                                onChange={(e) =>
                                                    handleVendor(e)
                                                }
                                                options={vendorOptions}
                                                value={purchaseInfo.vendor}
                                            />
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Order Date
                                        </label>
                                        <div className="col-lg-5">
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                type="date"
                                                name="orderDate"
                                                onChange={(e) => handleData(e)}
                                                value={purchaseInfo.orderDate}
                                            />
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Shipment Date
                                        </label>
                                        <div className="col-lg-5">
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                type="date"
                                                name="shipDate"
                                                onChange={(e) => handleData(e)}
                                                value={purchaseInfo.shipDate}
                                            />
                                        </div>
                                    </div>

                                    <div className="row form-group">
                                        <label className="col-lg-3 col-form-label required">
                                            Terms
                                        </label>

                                        <div className="col-lg-5">
                                            <Select
                                                onChange={(e) => handleTerms(e)}
                                                options={termsOptions}
                                                value={purchaseInfo.terms}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="row form-group">
                                            <label className="col-lg-3 col-form-label required">
                                                Invoice Number
                                            </label>
                                            <div className="col-lg-5">
                                                <input
                                                    type="text"
                                                    name="invoiceNumber"
                                                    onChange={(e) => handleData(e)}
                                                    className="form-control"
                                                    value={purchaseInfo.invoiceNumber}
                                                />
                                            </div>
                                        </div>
                                        <div className="row form-group">
                                            <label className="col-lg-3 col-form-label required">
                                                Invoice Date
                                            </label>
                                            <div className="col-lg-5">
                                                <input
                                                    autoComplete="off"
                                                    className="form-control"
                                                    type="date"
                                                    name="invoiceDate"
                                                    onChange={(e) => handleData(e)}
                                                    value={purchaseInfo.invoiceDate}
                                                    max={new Date().toISOString().split("T")[0]}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    {purchaseInfo?.vendor?.addressList ? (
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td style={{ minWidth: "100px" }}>
                                                        Billing:
                                                    </td>
                                                    <td>{purchaseInfo?.vendor?.billAdd?.state}</td>
                                                </tr>
                                                <tr>
                                                    <td>Shipping:</td>
                                                    <td>{purchaseInfo?.vendor?.shipAdd?.state}</td>
                                                </tr>
                                                <tr>
                                                    <td>PriceList:</td>
                                                    <td>{purchaseInfo?.vendor?.itemPriceListTitle}</td>
                                                </tr>
                                                <tr>
                                                    <td>Pay Terms:</td>
                                                    <td>{purchaseInfo?.vendor?.paymentTermTitle}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <br />
                        <hr />

                        <div className="customTable">
                            <table className="w-100">
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td>Sno.</td>
                                        <td style={{ minWidth: "100px" }}>
                                            Item
                                        </td>
                                        <td>Requested Qty</td>
                                        <td>Received Qty</td>
                                        <td>Pending Qty</td>
                                        <td style={{ width: "150px" }}>Unit</td>

                                        <td>Pack Rate</td>
                                        <td>Tax</td>
                                        <td>TaxAmt</td>
                                        <td>Amount</td>
                                        {!id && <td></td>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows
                                        ? rows?.map((data, i) => {
                                            return (
                                                <Fragment key={i}>
                                                    <tr>
                                                        <td>
                                                            <div className={itemLoading ? "spinner-loader" : ""}></div>
                                                        </td>
                                                        <td>{i + 1}</td>
                                                        <td
                                                            style={{
                                                                minWidth:
                                                                    "250px",
                                                            }}
                                                        >
                                                            <Select
                                                                isDisabled={itemOptions ? false : true}
                                                                style={{ zIndex: "20", }}
                                                                placeholder="Item"
                                                                options={itemOptions}
                                                                value={data.item}
                                                                onChange={(e) => handleItem(e, i)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                autoComplete="off"
                                                                type="number"
                                                                name="requestedQuantity"
                                                                min={1}
                                                                value={data.requestedQuantity}
                                                                onChange={(e) => handleQuantity(e, i)}
                                                                disabled={id ? true : false}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                autoComplete="off"
                                                                type="number"
                                                                min={0}
                                                                name="receivedQuantity"
                                                                value={data.receivedQuantity}
                                                                defaultValue={0}
                                                                onChange={(e) => handleQuantity(e, i)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                autoComplete="off"
                                                                type="number"
                                                                min={0}
                                                                name="pendingQuantity"
                                                                value={data.pendingQuantity}
                                                                defaultValue={0}
                                                                disabled
                                                            />
                                                        </td>
                                                        <td>
                                                            <Select
                                                                options={data.units}
                                                                value={data.unit1}
                                                                onChange={(e) => handleUnit(e, i)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                autoComplete="off"
                                                                type="number"
                                                                value={data.rate}
                                                                onChange={(e) => handleRate(e, i)}
                                                                disabled={!data.isFloating}
                                                            />
                                                        </td>
                                                        <td>{data.taxes?.title}</td>
                                                        <td>{data.taxes?.amount?.toFixed(2)}</td>
                                                        <td>{data.amount?.toFixed(2)}
                                                        </td>
                                                        {!id && <td
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => handleClear(data.item.value, i)}
                                                        >
                                                            <i className="fa fa-times"></i>
                                                        </td>}
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={1}></td>
                                                        <td colSpan={10}>
                                                            <table className="w-100 border text-center">
                                                                <thead>
                                                                    <tr className="border">
                                                                        <td> Qty <span className="text-danger">*</span></td>
                                                                        <td> Batch <span className="text-danger">*</span></td>
                                                                        <td> Mfg <span className="text-danger">*</span></td>
                                                                        <td> Expiry <span className="text-danger">*</span></td>
                                                                        <td> Store <span className="text-danger">*</span></td>
                                                                        <td> Rack <span className="text-danger">*</span></td>
                                                                        <td> Cell <span className="text-danger">*</span></td>
                                                                        <td> Pallete <span className="text-danger">*</span></td>
                                                                        <td className="text-right">
                                                                            <button
                                                                                id="ember1426"
                                                                                className="btn btn-default addbtn"
                                                                                onClick={() => addNewItemBachDetailRow(i)}
                                                                            >
                                                                                <AddIcon
                                                                                    style={{ color: "blue", }}
                                                                                />{" "}
                                                                                Add
                                                                                More
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {data.billBatchBeansList &&
                                                                        data.billBatchBeansList.map((itemBatchDetailObj, j) => (
                                                                            <tr key={i + "" + j} >
                                                                                <td>
                                                                                    <input
                                                                                        type="number"
                                                                                        name="batchQuantity"
                                                                                        onChange={(e) => itemDetailTextChange(e, i, j)}
                                                                                        value={itemBatchDetailObj.batchQuantity}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="text"
                                                                                        name="batchNumber"
                                                                                        onChange={(e) => itemDetailTextChange(e, i, j)}
                                                                                        value={itemBatchDetailObj.batchNumber}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="batchManufacturingDate"
                                                                                        onChange={(e) => itemDetailTextChange(e, i, j)}
                                                                                        value={itemBatchDetailObj.batchManufacturingDate}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type="date"
                                                                                        name="batchExpiredDate"
                                                                                        onChange={(e) => itemDetailTextChange(e, i, j)}
                                                                                        value={itemBatchDetailObj.batchExpiredDate}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <Select
                                                                                        styles={{
                                                                                            control: (base) => ({
                                                                                                ...base,
                                                                                                width: '150px'
                                                                                            }),
                                                                                            menu: (base) => ({
                                                                                                ...base,
                                                                                                width: '150px',
                                                                                            }),
                                                                                        }}
                                                                                        isDisabled={storeOptions ? false : true} options={storeOptions}
                                                                                        value={itemBatchDetailObj.store} placeholder={"Select Store"}
                                                                                        onChange={(e) => handleSelectBeanBatch(e, "store", i, j)} />
                                                                                </td>
                                                                                <td>
                                                                                    <Select
                                                                                        styles={{
                                                                                            control: (base) => ({
                                                                                                ...base,
                                                                                                width: '100px',
                                                                                            }),
                                                                                            menu: (base) => ({
                                                                                                ...base,
                                                                                                width: '100px',
                                                                                            }),
                                                                                        }}
                                                                                        isDisabled={itemBatchDetailObj.store !== "" ? false : true}
                                                                                        options={rackOptions} value={itemBatchDetailObj.rack} placeholder={"Select Rack"}
                                                                                        onChange={(e) => handleSelectBeanBatch(e, "rack", i, j)} />
                                                                                </td>
                                                                                <td>
                                                                                    <Select
                                                                                        styles={{
                                                                                            control: (base) => ({
                                                                                                ...base,
                                                                                                width: '100px',
                                                                                            }),
                                                                                            menu: (base) => ({
                                                                                                ...base,
                                                                                                width: '100px',
                                                                                            }),
                                                                                        }}
                                                                                        isDisabled={itemBatchDetailObj.rack !== "" ? false : true} options={cellOptions} value={itemBatchDetailObj.cell}
                                                                                        placeholder={"Select Cell"} onChange={(e) => handleSelectBeanBatch(e, "cell", i, j)} />
                                                                                </td>
                                                                                <td>
                                                                                    <Select
                                                                                        styles={{
                                                                                            control: (base) => ({
                                                                                                ...base,
                                                                                                width: '100px',
                                                                                                marginLeft: "10%"
                                                                                            }),
                                                                                            menu: (base) => ({
                                                                                                ...base,
                                                                                                width: '100px',
                                                                                            }),
                                                                                        }}
                                                                                        isDisabled={itemBatchDetailObj.cell !== "" ? false : true} options={palleteOptions} value={itemBatchDetailObj.pallete}
                                                                                        placeholder={"Select Pallete"} onChange={(e) => handleSelectBeanBatch(e, "pallete", i, j)} />
                                                                                </td>
                                                                                <td className="text-right">
                                                                                    <button
                                                                                        className="btn btn-default addbtn"
                                                                                        onClick={() => removeItemBachDetailRow(i, j)} >
                                                                                        <i className="fa fa-times"></i>
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                        )}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </Fragment>
                                            );
                                        })
                                        : null}
                                </tbody>
                            </table>
                        </div>

                        {!id && <button
                            id="ember1426"
                            className="btn btn-default addbtn mt-3"
                            onClick={handleAddNewRow}
                        >
                            <AddIcon style={{ color: "blue" }} /> New Row
                        </button>}

                        <br />
                        <br />
                        <div className="row justify-content-between">
                            <div className="col-lg-4">
                                <table className="customTable w-100">
                                    <tbody>
                                        <tr>
                                            <td>Notes</td>
                                            <td>
                                                <textarea
                                                    className="form-control"
                                                    name="notes"
                                                    onChange={(e) => handleData(e)}
                                                    value={purchaseInfo.notes}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Reference</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    className="form-control"
                                                    name="reference"
                                                    onChange={(e) => handleData(e)}
                                                    value={
                                                        purchaseInfo.reference
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-lg-2 d-lg-block d-none"></div>
                            <div className="col-lg-6">
                                <table className="customTable w-100">
                                    <tbody>
                                        <tr>
                                            <td colSpan={3}>Subtotal</td>
                                            <td>
                                                {Number(purchaseInfo?.subTotal).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Shipping [HSN: 996511]:</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    value={purchaseInfo.shipCharge}
                                                    onChange={(e) => handleShipCharge(e)}
                                                />
                                            </td>
                                            <td>
                                                <Select
                                                    onChange={(e) => handleShipTax(e)}
                                                    options={taxOptions}
                                                    value={purchaseInfo.shipTax}
                                                    isDisabled={itemOptions ? false : true}
                                                />
                                            </td>
                                            <td>
                                                {Number(purchaseInfo?.netShip).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>Total Tax</td>
                                            <td>
                                                {Number(purchaseInfo?.netTax).toFixed(2)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>TCS</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    value={purchaseInfo.tcsRate}
                                                    onChange={(e) => handleTcsRate(e)}
                                                    min={0}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>Discount</td>
                                            <td>
                                                <input
                                                    autoComplete="off"
                                                    type="number"
                                                    value={purchaseInfo.discountAmt}
                                                    onChange={(e) => handleDiscount(e)}
                                                    min={0}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={3}>Total</td>
                                            <td>
                                                {Number(purchaseInfo?.total - purchaseInfo.discountAmt).toFixed(2)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="text-left mt-3 mb-4">
                            {loading ? (
                                <Button
                                    variant="contained"
                                >
                                    <Spinner />
                                </Button>
                            ) : (
                                <Button
                                    variant="contained"
                                    onClick={handleSave}
                                >
                                    Save
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Toaster />
        </>
    );
};

export default BillNew;
